export default function About(){
    return (
        <h1>Welcome to my stocks app</h1>
    )
}